import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ErrorMessage } from 'ng-bootstrap-form-validation';
import { MainService } from '../../../../services';
import { Messaggio, Immobile, ServizioAcquistato } from '../../../../models';

@Component({
  selector: 'app-dialog-invia-messaggio',
  templateUrl: './dialog-invia-messaggio.component.html',
  styleUrls: ['./dialog-invia-messaggio.component.css']
})
export class DialogInviaMessaggio implements OnInit {

  errorObj: { error: boolean , errorMsg: string} = { error: false, errorMsg: ''};
  formGroup: FormGroup;
  messaggio: Messaggio;
  loading: boolean = false;
  titolo: string;

  constructor(public dialogRef: MatDialogRef<DialogInviaMessaggio>,
    private mainService: MainService,
    @Inject(MAT_DIALOG_DATA) public data: {immobile: Immobile, servizio: ServizioAcquistato, messaggio: Messaggio}) 
  { 
    dialogRef.disableClose = true;
    this.messaggio = new Messaggio();
    if(data.immobile !== undefined) {
      this.messaggio.immobile = data.immobile;
      this.titolo = 'Immobile #Rif. ' 
              + this.messaggio.immobile.riferimento.toLocaleString('it-IT', {minimumIntegerDigits: 6}).replace('.', '');
    } else if (data.servizio !== undefined) {
      this.messaggio.servizio = data.servizio;
      this.titolo = 'Appuntamento per erogazione servizio ' + data.servizio.tipologiaServizio.descrizione;
    } else {
      this.messaggio.oggetto = 'RE: ' + data.messaggio.oggetto;
      this.messaggio.destinatario = data.messaggio.mittente;
      this.titolo = 'Invia messaggio';
    }
    this.messaggio.dataCreazione = new Date();
  }
 
  ngOnInit() {
    this.formGroup = new FormGroup({
      oggetto: new FormControl('', [Validators.required]),
      messaggio: new FormControl('', [Validators.required])
    });
  }

  invia() {
    this.loading = true;
    if (this.formGroup.valid) {
      this.errorObj = {error: false, errorMsg: ''};
      this.mainService.tokenExpiredService.ifTokenNotExpired().subscribe(
        response => {
          if(response) {
            this.mainService.messaggioService.post(this.messaggio).subscribe(
              () => { 
                this.dialogRef.close();
                this.loading = false;
                this.mainService.alertService.success('Il suo messaggio è stato inviato!');
              },
              () => {
                this.errorObj = {error: true, errorMsg: 'ERRORE: Il messaggio non è stato inviato!'};
                this.loading = false;
              }
            );
          }
      });
    } else {
      this.errorObj = {error: true, errorMsg: 'ERRORE: Verificare il messaggio!'};
      this.loading = false;
    }
  }

  required: ErrorMessage[] = [
    {
      error: 'required',
      format: (label, error) => ``
    }
  ];
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/components/utilita/dialogs/dialog-invia-messaggio/dialog-invia-messaggio.component.ts